import { render, staticRenderFns } from "./ExpiredToken.vue?vue&type=template&id=bb8247d0&scoped=true"
import script from "./ExpiredToken.vue?vue&type=script&lang=ts"
export * from "./ExpiredToken.vue?vue&type=script&lang=ts"
import style0 from "./ExpiredToken.vue?vue&type=style&index=0&id=bb8247d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8247d0",
  null
  
)

export default component.exports